import gql from 'graphql-tag';

const mutation = gql`
  mutation SaveUserData(
    $birthDate: Date!
    $isFemale: Boolean!
    $height: UserMeasurementHeightInputType
  ) {
    me {
      saveUserData(birthDate: $birthDate, isFemale: $isFemale, height: $height) {
        ... on BasicMutationSuccess {
          code
          __typename
        }

        ... on ValidationException {
          code
          __typename
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;

export default mutation;
